module.exports = __webpack_public_path__ + "img/WB2024.b1537818.jpg";